// extracted by mini-css-extract-plugin
module.exports = {"infomsg":"zkX2K","icon":"k5e8_","right":"OYQVR"};